export type PaletteNames = "standard" | "crazy"

export const standard = [
  "white",
  "yellow",
  "orange",
  "rgb(100, 172, 255)",
  "Crimson",
  "Plum",
  "LimeGreen",
  "black"
];

export const crazy = [
  "white", 
  "#BBBBBB",
  "#888888",
  "#444444",
  "black",
  "#FFFF00",
  "#FFBB00",
  "#FF8800",
  "#FF5500",
  "#FF0000",
  "#CC0000",
  "#880000",
  "#8800FF",
  "#FF00FF",
  "#FFAAFF",
  "#FFCCFF",
  "#0000FF",
  "#0088FF",
  "#00FFFF",
  "#88FF88",
  "#00FF00",
  "#008800",
  "#558800"
];
